// extracted by mini-css-extract-plugin
export var actionsRow = "_18-a";
export var actionsRowEnd = "_18-b";
export var askRedoBlackBtn = "_18-d";
export var askRedoBlackBtnIcon = "_18-e";
export var exitModalActionBtn = "_18-c";
export var exitModalRoot = "_18-0";
export var followUpInput = "_18-9";
export var modalContentBody = "_18-7";
export var modalHeaderImage = "_18-2";
export var modalImageLabel = "_18-4";
export var modalImageOverlay = "_18-3";
export var modalImageSubheading = "_18-6";
export var modalImageTitle = "_18-5";
export var modalImageWrapper = "_18-1";
export var reasonCard = "_18-f";
export var reasonCardSelected = "_18-g";
export var reasonIcon = "_18-j";
export var reasonIconWrap = "_18-i";
export var reasonIndicator = "_18-l";
export var reasonIndicatorDot = "_18-n";
export var reasonIndicatorSelected = "_18-m";
export var reasonLabel = "_18-h";
export var reasonList = "_18-8";
export var reasonTitle = "_18-k";